import type { Id } from '@e-socna/data-layer';

import { OPEN } from '../../Access/utils/access-gate.util';
import type { AccessGate } from '../../Access/types/access-gate.type';
import type { Mode } from '../types/mode.type';
import type {
  FileCategoryAccess,
  FileCategoryAccesses,
} from '../types/file-category-access.type';

const OPEN_ACCESS: FileCategoryAccess = { download: OPEN, upload: OPEN };

// Without accesses (an explorer outside the business entities), every category is open.
export const fileCategoryAccessOf = (
  accesses: FileCategoryAccesses | undefined,
  fileCategoryId: Id | null,
): FileCategoryAccess =>
  (fileCategoryId ? accesses?.get(fileCategoryId) : undefined) ?? OPEN_ACCESS;

// A category where the user may neither consult nor upload.
export const isFileCategoryLocked = ({
  download,
  upload,
}: FileCategoryAccess): boolean => !download.isAllowed && !upload.isAllowed;

export const lockReasonsOf = ({
  download,
  upload,
}: FileCategoryAccess): readonly string[] => [
  ...new Set([...download.reasons, ...upload.reasons]),
];

// The content and the gallery consult the files, the upload adds some.
export const modeGateOf = (
  { download, upload }: FileCategoryAccess,
  mode: Mode,
): AccessGate => (mode === 'upload' ? upload : download);
